import { FiCheckCircle, FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import SitePreview from "../UI/SitePreview";
import StarRating from "../UI/StarRating";

const WebsiteCard = ({ site, viewMode = "grid", showRank = false, rank }) => {
  if (viewMode === "list") {
    return (
      <Link
        to={`/website/${site.id}`}
        className="card-hover flex items-center gap-4 px-5 py-4 group"
      >
        {showRank && (
          <span
            className={`w-9 h-9 rounded-xl flex items-center justify-center text-sm font-extrabold flex-shrink-0 ${
              rank <= 3
                ? "bg-amber-100 text-amber-700 ring-2 ring-amber-200"
                : "bg-slate-100 text-slate-500"
            }`}
          >
            {rank}
          </span>
        )}
        <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0 ring-2 ring-slate-100">
          <SitePreview
            url={site.url}
            alt={site.name}
            className="w-full h-full"
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5">
            <span className="text-sm font-bold text-slate-900 group-hover:text-indigo-600 transition-colors truncate">
              {site.name}
            </span>
            {site.verified && (
              <FiCheckCircle
                size={13}
                className="text-indigo-500 flex-shrink-0"
              />
            )}
            {site.featured && (
              <span className="badge-blue text-[9px]">Featured</span>
            )}
          </div>
          <p className="text-xs text-slate-500 font-medium truncate mt-0.5">
            {site.description}
          </p>
        </div>
        <div className="hidden md:flex items-center gap-2">
          <StarRating rating={site.rating} size="xs" />
          <span className="text-sm font-extrabold text-slate-900">
            {site.rating}
          </span>
        </div>
        <span className="badge-slate hidden lg:inline-flex">
          {site.category}
        </span>
        <FiChevronRight
          size={14}
          className="text-slate-300 group-hover:text-indigo-500 flex-shrink-0 transition-colors"
        />
      </Link>
    );
  }

  return (
    <Link
      to={`/website/${site.id}`}
      className="card-hover block group overflow-hidden h-full"
    >
      <div className="relative">
        <SitePreview
          url={site.url}
          alt={site.name}
          className="h-44"
          imgClassName="group-hover:scale-105 transition-transform duration-700"
        />
        {showRank && (
          <div
            className={`absolute top-3 left-3 w-8 h-8 rounded-lg flex items-center justify-center text-xs font-extrabold shadow-md z-20 ${
              rank <= 3
                ? "bg-amber-400 text-amber-950"
                : "bg-white/90 text-slate-700"
            }`}
          >
            {rank}
          </div>
        )}
        {site.featured && (
          <div className="absolute top-3 right-3 z-20">
            <span className="badge bg-amber-400 text-amber-950 border-transparent text-[9px] font-bold uppercase tracking-wider">
              Featured
            </span>
          </div>
        )}
      </div>
      <div className="p-4">
        <div className="flex items-center gap-1.5 mb-1">
          <h3 className="text-sm font-bold text-slate-900 group-hover:text-indigo-600 transition-colors truncate">
            {site.name}
          </h3>
          {site.verified && (
            <FiCheckCircle
              size={12}
              className="text-indigo-500 flex-shrink-0"
            />
          )}
        </div>
        <p className="text-xs text-slate-500 font-medium line-clamp-2 leading-relaxed mb-3">
          {site.description}
        </p>
        <div className="flex items-center justify-between pt-3 border-t-2 border-slate-100">
          <div className="flex items-center gap-1.5">
            <StarRating rating={site.rating} size="xs" />
            <span className="text-xs font-extrabold text-slate-900">
              {site.rating}
            </span>
            <span className="text-[10px] text-slate-400 font-semibold">
              ({site.totalReviews})
            </span>
          </div>
          <span className="badge-slate text-[10px]">{site.category}</span>
        </div>
      </div>
    </Link>
  );
};

export default WebsiteCard;
